import { Component, OnInit } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    
    constructor(
        private cookieConsentService: NgcCookieConsentService) { }

    ngOnInit() {

        // Destroys cookie consent to avoid showing it on loading page.
        this.cookieConsentService.destroy();
        
    }
     
}
